import { Dropdown } from "@sportal/cdk";

import "./Dropdown.scss";

export { Dropdown };
